<compass-stage-breadcrumbs></compass-stage-breadcrumbs>
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<compass-line-transit *ngIf="transitLines$ | async as transitLines; else loading" [areaTransit]="transitLines">
</compass-line-transit>